<template>
<div v-if="isShow">
  <!-- 这是弹窗登录 -->
  <div v-if="isShowLoginPop" class="active-pop-contian">
            <div class="pup-content">
                <div class="content">
                    <div class="text-div">点击“立即登录”，登录荣耀会员参与活动</div>
                    <template v-if="loginType==='Alipay'">
                        <div class="btn-div" @click="aliPayJumpLogin">立即登录</div>
                    </template>
                    <template v-if="loginType==='wechat'">
                        <div v-if="miniProgramFlag" class="btn-div" @click="wxJumpLogin">立即登录</div>
                        <wx-open-launch-weapp v-else
                            id="launch-btn"
                            :username="hiHonorWxAppId"
                            :env-version="envVersion"
                            :path="`pages/tabBar/index/index?activityUrl=${encodeURIComponent(activityUrlInner)}`">
                            <script type="text/wxtag-template">
                                <div style="font-size: 16px;
                                    color: #FFFFFF;
                                    letter-spacing: 0;
                                    text-align: center;
                                    height: 36px;
                                    line-height: 36px;
                                    border-radius: 18px;
                                    font-weight: 400;
                                    padding-left: 10px;
                                    padding-right: 10px;
                                    background-color: #256fff;
                                    margin-top: 34px;
                                    width: 130px;">立即登录</div>
                            </script>
                        </wx-open-launch-weapp>
                    </template>
                </div>
				<div class="close-btn"><img :src="close" class="close-img" @click="closePop"></div>
            </div>
    </div>
<!-- 这是下方的横幅登录 -->
  <div v-else class="notice-auth">
        <div class="text-class">
            您还未登录，登录荣耀会员参与活动
        </div>
        <template v-if="loginType==='Alipay'">
            <div class="custom-style"
                @click="aliPayJumpLogin">立即登录</div>
        </template>
        <template v-if="loginType==='wechat'">
            <div v-if="miniProgramFlag"
                class="custom-style"
                @click="wxJumpLogin">立即登录</div>
            <wx-open-launch-weapp v-else
                id="launch-btn"
                :username="hiHonorWxAppId"
                :env-version="envVersion"
                :path="`pages/tabBar/index/index?activityUrl=${encodeURIComponent(activityUrlInner)}`">
                <script type="text/wxtag-template">
                    <div style="height: 28px;
                  background: #256fff;
                  border-radius: 14px;
                  font-size: 10px;
                  padding: 0 15px;
                  color: #ffffff;
                  letter-spacing: 0;
                  line-height: 28px;
                  font-weight: 400;">立即登录</div>
                </script>
            </wx-open-launch-weapp>
        </template>
  </div>
</div>
</template>
<script>
// loginType=wechat/alipay  微信环境/支付宝环境  miniProgramFlag=true/false 微信、支付宝小程序环境/微信、支付宝浏览器环境
import wx from 'weixin-js-sdk';
import { loadAlipayWebViewScript,getUrlParams } from '../../../../../utils/comUtils.js';
import { config as configEnv } from '../../../../../commons/config.js';
import { getEnvMark, getWxSDKAuth } from '../../common-methods/utils';
import { EnvMark } from '../../lucky-draw/common/global-variable.js';
import { config } from '@/api/config.js';
export default {
  props: {
    // 是否登录
    isLoginFlag: {
      type: Boolean,
      default: true,
    },
    // 活动链接
    activityUrl: {
      type: String,
      default: '',
    },
    loginType: {
      type: String,
      default: '',
    },
    // 是否为会员，默认是会员
    isMemberId: {
      type: [Boolean, String],
      default: true,
    },
    // 是否需要获取微信授权
    isNeedWxAuth: {
      type: Boolean,
      default: true,
    },
    showLoginPop:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      close: 'https://hshop.honorfile.com/pimages/pages/cdnImages/38974835077613847983.png',
      envVersion: configEnv.env === 'pro' ? 'release' : 'trial',
      miniProgramFlag: true, // 判断是否在小程序环境内打开
      activityUrlInner: '',
      isShowLoginPop:false,
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  computed: {
    // 是否是会员
    isMemberInner() {
      // 对传入的字段，进行字符串和布尔值场景进行兼容
      return this.isMemberId === 'true' || this.isMemberId === true;
    },
    // 是否展示该组件，未登录，或不是会员，均需要进行展示
    isShow() {
      console.log('this.loginTypeL',this.loginType)
      console.log('this.isLoginFlagL',this.isLoginFlag)
      console.log('this.isMemberInnerL',this.isMemberInner)
      return this.loginType !== 'none' && (!this.isLoginFlag || !this.isMemberInner);
    },
  },
  watch: {
    activityUrl: {
      immediate: true,
      handler(newVal) {
        this.activityUrlInner = newVal;
        const activityListId = sessionStorage.getItem('activityListId');
        if (activityListId && activityListId !== 'null' && activityListId !== 'undefined') {
          this.activityUrlInner += `&activityListId=${activityListId}`;
        }
        const params = getUrlParams()
        if(params && params.taskCode && params.from && params.from === 'qywxMini'){
          this.activityUrlInner += `&from=qywxMini&taskCode=${params.taskCode}`;
        }
        console.log('this.activityUrlInner===>login-in',this.activityUrlInner)
        },
    },
    showLoginPop:{
      immediate: true,
      handler(newVal) {
        this.isShowLoginPop = newVal
      }
    }
  },
  created() {
    try {
      const env = getEnvMark();
      this.miniProgramFlag = env === EnvMark.wechatMp || env === EnvMark.alipayMp;
      // 微信H5场景，需要获取开放标签的权限
      if (env === EnvMark.wechatH5 && this.isNeedWxAuth) {
        getWxSDKAuth();
      }
    } catch (err) {
      // 若上述方法出错，则使用备用方法
      this.miniProgramFlag = window.__wxjs_environment === 'miniprogram';
    }
  },
  mounted() {
    console.log('loginType=====>login-in', this.loginType);
    console.log('isLoginFlag=====>login-in', this.isLoginFlag);
    console.log('isMemberInner=====>login-in', this.isMemberInner);
    console.log('miniProgramFlag=====>login-in', this.miniProgramFlag);
    console.log('envVersion=====>login-in', this.envVersion);
    console.log('activityUrl=====>login-in', this.activityUrl);
  },
  methods: {
    // 微信小程序， webview内跳转首页登录
    wxJumpLogin() {
      console.log('this.activityUrlInner===========>', this.activityUrlInner);
      // h5点击登陆后向小程序传参方便登陆成功后使用该标识再次跳转到当前h5页面
      wx.miniProgram.postMessage({
        h5LoginToMiniFlag: !this.isLoginFlag || true,
      });
      wx.miniProgram.reLaunch({
        url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrlInner),
        success: () => {
          // 清空缓存
          sessionStorage.setItem('activityListId', '');
        },
        fail: (res) => {
          console.log('微信，跳转回小程序的页面fail', res);
        },
      });
    },
    // 支付宝环境跳转登录
    aliPayJumpLogin() {
      //在支付宝小程序环境打开
      if (this.miniProgramFlag) {
        console.log('支付宝小程序1');
        console.log(this.activityUrlInner);
        loadAlipayWebViewScript().then(() => {
          my.postMessage({
            activityUrl: encodeURIComponent(this.activityUrlInner),
          });
          my.reLaunch({
            url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrlInner),
            success: () => {
              // 清空缓存
              sessionStorage.setItem('activityListId', '');
            },
            fail: (res) => {
              console.log('支付宝，跳转回小程序的页面fail', res);
            },
          });
        });
      } else {
        //在支付宝内部浏览器打开
        const templeQuery = encodeURIComponent(this.activityUrlInner);
        const query = encodeURIComponent(`activityUrl=${templeQuery}`);
        console.log('支付宝小程序2');
        console.log(query);
        window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=' + query;
        // 清空缓存
        sessionStorage.setItem('activityListId', '');
      }
    },
    closePop(){
      this.isShowLoginPop = false
    },
  },
};
</script>

<style lang="scss" scoped>
.active-pop-contian {
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 100;
    display: flex;
    align-items: center;
		justify-content: center;
    .pup-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80%;
			.content{
                width: 313px;
                height: 166px;
                border-radius: 12px;
                background: linear-gradient(#fff,#dce8ff);
                text-align: -webkit-center;
                .text-div{
                    font-size: 14px;
                    color: #000000;
                    text-align: center;
                    line-height: 22px;
                    font-weight: 400;
                    margin-top: 49px;
                }
                .btn-div{
                    font-size: 16px;
                    color: #FFFFFF;
                    letter-spacing: 0;
                    text-align: center;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 18px;
                    font-weight: 400;
                    padding-left: 10px;
                    padding-right: 10px;
                    background-color: #256fff;
                    margin-top: 34px;
                    width: 130px;
                }
			}
			.close-btn{
				height: 50px;
                position: relative;
                top: 15px;
          .close-img{
            height: 25px;
            width: 25px;
          }
        }
        }
    }
.notice-auth {
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 40px);
  left: 10px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  height: 50px;
  color: #ffffff;
  line-height: 50px;
  width: calc(100vw - 20px);
  z-index: 999;
    .custom-style {
      height: 28px;
      background: #256fff;
      border-radius: 14px;
      font-size: 10px;
      padding: 0 15px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 400;
    }
    .text-class {
      line-height: 28px;
      height: 28px;
      font-size: 12px;
    }
  }
</style>

 


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/login-in.vue